import { Loader2 } from 'lucide-react'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  text?: string
}

export default function LoadingSpinner({ size = 'md', text }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] gap-4">
      <Loader2 className={`${sizeClasses[size]} text-louis-gold animate-spin`} />
      {text && <p className="text-white/60 text-sm">{text}</p>}
    </div>
  )
}
